import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-menu p-d-flex p-jc-between p-ai-center p-p-3" }
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = { class: "ham-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("adminToolbar.welcome", { name: _ctx.globalStore.user.name })), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Button, {
        icon: "pi pi-bars",
        class: "p-button-rounded p-button-text",
        onClick: _ctx.emitMenuClick
      }, null, 8, ["onClick"])
    ])
  ]))
}